// @ts-check
import { h } from "./dom.js";
import { icon } from "./icons.js";

/** Add shared keyboard dismissal to a native disclosure, including static HTML.
 * @param {HTMLDetailsElement} element
 */
export function enhanceDisclosure(element) {
  element.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || event.defaultPrevented || !element.open)
      return;
    event.preventDefault();
    event.stopPropagation();
    element.open = false;
    element.querySelector("summary")?.focus();
  });
  return element;
}

/** Compact, anchored settings beside the tool they configure. Menus use menu().
 * @param {{ label: string, align?: "start" | "end", className?: string }} options
 * @param {...Node} children
 */
export function disclosure(
  { label, align = "start", className = "" },
  ...children
) {
  return enhanceDisclosure(
    h(
      "details",
      { class: `ui-disclosure ${className}`, dataset: { align } },
      h(
        "summary",
        { aria: { label } },
        h("span", { text: label }),
        icon("chevron-down"),
      ),
      h("div", { class: "ui-popover ui-disclosure__content" }, children),
    ),
  );
}
